import productTranslations from './product-translations.json';

export type ProductTranslations = typeof productTranslations;
export const defaultProductTranslations = productTranslations;
